import { Injectable } from '@angular/core';

// import { Observable, of } from 'rxjs/Rx';
import { tap, delay } from 'rxjs/operators';


@Injectable()
export class AuthService {
  isLoggedIn = false;

  // store the URL so we can redirect after logging in
  redirectUrl: string;

  /*login(): Observable<boolean> {
    return of(true).pipe(
      delay(1000),
      tap(val => this.isLoggedIn = true)
    );
  }

  logout(): void {
    this.isLoggedIn = false;
  }*/
}


// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/auth.service.ts